import CryptoJS from "crypto-js";
// const key = CryptoJS.enc.Utf8.parse('mySuperSecureEncryptionKey123');  
const secretKey = process.env.REACT_APP_AES_KEY; // 16 characters for AES-128
const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_STRING); // 16 characters for AES-128   // Use Utf8-Encoder.
 export const decryptMessage = (encryptedMessage) => {
    const decrypted = CryptoJS.AES.decrypt(encryptedMessage, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  };
  export const encryptMessage = (message) => {

    
    const encrypted = CryptoJS.AES.encrypt(message, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedData =encrypted.toString();
    const ivString =iv
    return { encryptedData, ivString };
    // return encrypted.toString();
  };


